<template>
    <v-row justify="center">
        <v-dialog v-model="dialogProp" persistent scrollable max-width="500">
            <ValidationObserver ref="obs" >
                <v-card>
                    <v-progress-linear
                        v-if="loading"
                        indeterminate
                        color="primary"
                        rounded
                        height="6"
                    ></v-progress-linear>

                    <v-card-title class="pa-0 shadow-1">
                        <v-img
                            :src="
                                require('@/assets/illustrations/bg_modal_card.svg')
                            "
                            cover
                            position="left bottom"
                            class="align-center"
                            height="65px"
                        >
                            <v-card-title
                                class="font-weight-medium primary--text"
                            >
                                Eliminar Categoria
                            </v-card-title>
                        </v-img>
                    </v-card-title>

                    <vuescroll
                        :ops="{
                            bar: { background: '#bacfcec0', keepShow: true }
                        }"
                    >
                        <v-card-text style="max-height: 350px">
                            <v-form>
                                <v-row dense>
                                    <v-col cols="12">
                                        <v-card-title
                                            class="font-weight-medium "
                                        >
                                            Esta seguro que desea eliminar esta
                                            pregunta? 
                                        </v-card-title>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-card-text>
                    </vuescroll>

                    <v-divider></v-divider>

                    <v-card-actions class="mx-2">
                        <v-spacer></v-spacer>
                        <v-hover v-slot:default="{ hover }">
                            <v-btn
                                text
                                rounded
                                class="mr-1"
                                :color="hover ? 'error' : 'grey'"
                                @click="closeDialog"
                                >Cancelar</v-btn
                            >
                        </v-hover>

                        <v-hover v-slot:default="{ hover }">
                            <v-btn
                                rounded
                                :loading="loading"
                                :disabled="loading"
                                color="error"
                                :class="hover ? 'shadow-2' : 'shadow-4'"
                                class="px-8"
                                @click="deleteAction()"
                                >Eliminar</v-btn
                            >
                        </v-hover>
                    </v-card-actions>
                </v-card>
            </ValidationObserver>
        </v-dialog>
    </v-row>
</template>

<script>
import vuescroll from "vuescroll";

export default {
    props: {
        item: {
            type: Object
        },
        dialogProp: {
            type: Boolean,
            default: false
        }
    },
    components: {vuescroll},
    data() {
        return {
            loading: false,
        };
    },

    methods: {
        closeDialog() {
            this.$emit("dialog:close")
        },
        async deleteAction() {
                this.loading = true
                await this.$store.dispatch("questions/DELETE_QUESTION", this.item.id)
                this.closeDialog()
                this.$snotify.success("Pregunta eliminada con exito", "¡Hecho!")
                this.loading = false
        }
        
        /*
        async sendform() {
            try {
                this.loading = true;
                const enviar = {
                    ClientName: this.ClientName,
                    ClientUser: this.ClientUser,
                    ClientPassword: this.ClientPassword,
                    ClientEmail: this.ClientEmail,
                    ClientIP: this.ClientIP,
                    ClientNameBd: this.ClientNameBd,
                    ClientPort: this.ClientPort,
                    ip_sokect: this.ip_sokect,
                    user_sokect: this.user_sokect,
                    clave_sokect: this.clave_sokect,
                    port_sokect: this.port_sokect
                };
                const response = await this.$store.dispatch(
                    "clients/REGISTER_CLIENTS",
                    enviar
                );
                this.loading = false;
                this.dialogVisible = false;
                this.resetform();
            } catch (error) {
                this.$snotify.error(error.response.data, "¡Error!");
                // this.errorData = error.response.data;
                // this.activeAlert = true;
                // this.colorAlert = "red";
                this.loading = false;
            }
        },*/
    }
};
</script>
